<template>
	<a
		class="card card--no-gutter news-list-item list-item grid-noGutter"
		:class="{ 'list-item--mounted': isMounted }"
		:href="data.link"
	>
		<span class="news-list-item_icon" v-html="IconDocument"></span>
		<div
			v-if="!showPattern"
			class="news-list-item__image"
			v-html="data.image"
		></div>
		<div
			v-if="showPattern"
			class="news-list-item__pattern"
			v-html="Pattern"
		></div>
		<div class="news-list-item__copy">
			<p
				class="news-list-item__date"
				:aria-describedby="'news-title__' + data.id"
				v-if="data.date && !data.dateNumeric"
			>
				{{ formatDate(data.date) }}
			</p>
			<p
				class="news-list-item__date"
				:aria-describedby="'news-title__' + data.id"
				v-else-if="data.dateNumeric"
			>
				{{ data.dateNumeric }}
			</p>
			<h3
				class="news-list-item__title header-extra-small"
				:id="'news-title__' + data.id"
			>
				{{ data.title }}
			</h3>
			<span class="news-list-item__description body-text-small">
				{{ data.description }}
			</span>
		</div>
	</a>
</template>
<script setup>
import { ref, computed, onMounted } from 'vue';
import IconDocument from "../../../../views/icons/document.cshtml";
import Pattern from "../../../../views/visuals/leafPatternLarge.cshtml";

const props = defineProps(['data']);
const isMounted = ref(false);

const showPattern = computed(() => {
	return props.data.image.length === 0;
});

const formatDate = (date) => {
	return utilities.formatDate(date);
};

onMounted(() => {
	setTimeout(() => {
		isMounted.value = true;
	}, 10);
});
</script>
